import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { LaunchingSoon } from "./Shared";

export const RoleDemoCTA = ({ role, cta }) => (
  <Link
    to="/contact"
    data-testid={`role-demo-cta-${role.toLowerCase().replace(/\s+/g, "-")}`}
    className="btn-primary px-6 py-3 text-sm inline-flex items-center gap-2"
  >
    {cta || `Explore the ${role} Experience`} <ArrowRight size={15} />
  </Link>
);

/* Premium "behind the demo" panel — communicates value without exposing full UI. */
export const DemoPreview = ({ role, title, blurb, cta }) => (
  <div className="relative rounded-2xl overflow-hidden border border-white/10 bg-[#0B1240] p-8 md:p-10 min-h-[340px] flex flex-col justify-center"
    data-testid={`demo-preview-${role.toLowerCase().replace(/\s+/g, "-")}`}>
    <div className="absolute inset-0 grid-lines opacity-40" />
    <div className="absolute inset-0 radial-glow" />
    {/* soft blurred dashboard hint */}
    <div className="absolute -right-10 -bottom-10 opacity-[0.12] blur-[2px] pointer-events-none">
      <div className="grid grid-cols-3 gap-3 w-[320px]">
        {[...Array(6)].map((_, i) => <div key={i} className="h-16 rounded-xl bg-white/40" />)}
      </div>
    </div>
    <div className="absolute top-5 right-5 z-10">
      <LaunchingSoon tone="dark" label="Launching Soon" />
    </div>
    <div className="relative">
      <span className="inline-flex items-center gap-2 text-[11px] font-mono-accent uppercase tracking-widest text-[#F1BF26]">
        <Sparkles size={13} /> Personalised demo
      </span>
      <h3 className="font-display text-2xl font-semibold text-white mt-4 leading-tight">{title}</h3>
      <p className="text-white/55 text-[15px] leading-relaxed mt-3 max-w-md">{blurb}</p>
      <div className="mt-7"><RoleDemoCTA role={role} cta={cta} /></div>
    </div>
  </div>
);
